import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetByIdTipoAccion } from "@/shared/actions";
import SaveTipoAccion from "../../components/save-tipo-accion/SaveTipoAccion";

export default function UpdateTipoAccionPage() {
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useFetchGetByIdTipoAccion(id!);
  if (isLoading || isRefetching) return <LoaderComponent />;
  return <SaveTipoAccion titulo="Actualizar tipo de acción" data={data?.data} />;
}
